import { render, staticRenderFns } from "./UserContext.vue?vue&type=template&id=1a505064&scoped=true"
import script from "./UserContext.vue?vue&type=script&lang=js"
export * from "./UserContext.vue?vue&type=script&lang=js"
import style0 from "./UserContext.vue?vue&type=style&index=0&id=1a505064&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a505064",
  null
  
)

export default component.exports